module.exports = __webpack_public_path__ + "img/google_icon_mark.b56d8a20.png";